export default {
  // General
  affiliateProgram: "Referral Partner Program",
  becomeAffiliate: "Become a Referral Partner",
  affiliateDashboard: "Affiliate Dashboard",
  referralPartner: "Referral Partner",
  referralPartners: "Referral Partners",

  // Signup
  affiliateSignupTitle: "Join Our Referral Partner Program",
  affiliateSignupDesc: "Facilitate DOOH campaign bookings for your clients and earn commissions on every deal",
  applicantName: "Full Name",
  companyNameOptional: "Company / Agency Name (Optional)",
  applicantType: "Applicant Type",
  individual: "Individual",
  agency: "Agency",
  salesExperience: "Sales / Marketing Experience",
  whyAffiliate: "Why do you want to become a referral partner?",
  websiteUrl: "Website / Portfolio URL",
  applicationPending: "Application Pending",
  applicationPendingDesc: "Your referral partner application is under review. We'll notify you once it's processed.",
  applicationApproved: "Application Approved",
  applicationApprovedDesc: "Congratulations! You are an approved referral partner.",
  applicationRejected: "Application Rejected",
  applicationRejectedDesc: "Unfortunately your application was rejected.",
  rejectionReason: "Rejection Reason",
  submitApplication: "Submit Application",
  applicationSubmitted: "Application Submitted!",
  applicationSubmittedDesc: "Your referral partner application is under review. We'll notify you soon.",
  alreadyApplied: "You have already applied",

  // Dashboard Tabs
  overview: "Overview",
  createCampaign: "Create Campaign",
  myBookings: "My Bookings",
  commissions: "Commissions",
  clients: "Clients",
  profile: "Profile",
  support: "Support",

  // Dashboard - Overview
  totalSales: "Total Sales",
  totalCommission: "Total Commission",
  pendingCommission: "Pending Commission",
  activeClients: "Active Clients",
  totalBookings: "Total Bookings",
  manageReferrals: "Manage your referrals and commissions",

  // Dashboard - Bookings
  referrals: "Referrals",
  noReferrals: "No referrals yet",
  noReferralsDesc: "Share your referral link to start earning commissions",
  noBookings: "No bookings yet",
  noBookingsDesc: "Create a campaign on behalf of a client to get started",
  saleAmount: "Sale Amount",
  commission: "Commission",
  status: "Status",
  pending: "Pending",
  confirmed: "Confirmed",
  paid: "Paid",
  viewInvoice: "View Invoice",
  viewPO: "View PO",
  campaignName: "Campaign",
  client: "Client",
  budget: "Budget",
  dates: "Dates",

  // Dashboard - Clients
  noClients: "No clients yet",
  noClientsDesc: "Clients are automatically added when you create campaigns on their behalf",
  clientName: "Client Name",
  clientEmail: "Email",
  clientCompany: "Company",
  clientPhone: "Phone",
  totalSpend: "Total Spend",
  campaignsCount: "Campaigns",
  addClient: "Add Client",
  editClient: "Edit Client",
  deleteClient: "Delete Client",
  clientNotes: "Notes",

  // Campaign Creation
  clientInformation: "Client Information",
  clientInfoDesc: "Enter the client details for this campaign booking",
  onBehalfOf: "Booking on behalf of client",

  // Admin
  affiliateApplications: "Referral Partners",
  approveAffiliate: "Approve",
  rejectAffiliate: "Reject",
  rejectAffiliateTitle: "Reject Partner",
  rejectAffiliateConfirm: "Are you sure you want to reject this application?",
  confirmRejection: "Confirm Rejection",
  affiliateApproved: "Partner Approved",
  affiliateApprovedDesc: "has been approved as a referral partner",
  affiliateRejected: "Partner Rejected",
  affiliateRejectedDesc: "has been rejected",
  noApplications: "No applications in this category",

  // Program Page
  programHeroTitle: "Earn by Facilitating DOOH Campaign Bookings",
  programHeroDesc: "Join our Referral Partner Program and earn commissions by bringing advertisers to book campaigns. You manage the client relationship — we handle the rest.",
  roleTitle: "Role of a Referral Partner",
  roleDesc: "As a referral partner, you identify and engage potential advertisers, present campaign options, and facilitate the entire booking process on behalf of your clients.",
  bookingFlowTitle: "How the Booking Flow Works",
  whatPartnersDoTitle: "What Partners Do",
  whatPartnersDontDoTitle: "What Partners Don't Do",
  platformHandlesTitle: "What the Platform Handles",
} as const;
